import { Sexes } from "~/common/utils";
import {
  SCREENING_QUESTION_CODES,
  SCREENING_QUESTION_TYPES,
} from "~/common/utils/consultations/screening";

export const sexQuestions = {
  [SCREENING_QUESTION_CODES.sex]: {
    title: "What is your sex?",
    type: SCREENING_QUESTION_TYPES.radio,
    options: Sexes,
  },
} as const;
